import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/*
N.B. This component is provisionally deprecated - consider using
`hub-components/centre-selector` instead.
*/

/* eslint-disable react/sort-comp */
/* eslint-disable react/no-multi-comp */
import React, { useState, useCallback, useMemo, useContext } from 'react';
import Icon from "@scentregroup/ui/components/icon";
import Spinner from "@scentregroup/ui/components/spinner";
import CentrePicker from '@scentregroup/shared/hub-components/centre-picker';
import analyticsUtils from '../../helpers/analytics-utils';
import trackClickEvent from '../../helpers/analytics-utils/track-event';
import getNearestCentres from '../../helpers/get-nearest-centres';
import { useRecentCentres } from '../../hooks/use-recent-centres';
import { LinkContext } from '../../context';
import { useAnalytics } from '../../analytics';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const defaultCentreSelectorConfig = {
  inputLabel: '',
  locationLabel: 'Or use your current location',
  suggestedCentresLabel: 'Suggested',
  id: 'centre-selector'
};
export const MAX_SUGGESTIONS = 3;
const trackSearchStarted = () => {
  analyticsUtils.gaTagTracking({
    event: analyticsUtils.events.SEARCH,
    eventCategory: analyticsUtils.categories.CENTRE_SEARCH,
    eventAction: analyticsUtils.actions.CLICK_TO_START_SEARCH
  });
};
export const getCentreDisplayTitle = centre => {
  if (!centre) {
    return '';
  }
  const location = centre.suburb === centre.title ? centre.state : "".concat(centre.suburb, ", ").concat(centre.state);
  return "".concat(centre.title, ", ").concat(location);
};
const centreToString = centre => centre && centre.displayTitle ? centre.displayTitle : '';
const FormCentrePickerAs = props => /*#__PURE__*/_jsx("form", _objectSpread(_objectSpread({
  action: "#"
  /* no-op but makes iOS use 'SEARCH' as return key type */,
  onSubmit: e => e.preventDefault()
}, props), {}, {
  "data-id": "centre-selector_index_FormCentrePickerAs_form",
  children: props.children
}));
export const CentreSelector = _ref => {
  let {
    centres,
    centre: currentCentre,
    navStyle,
    config = defaultCentreSelectorConfig,
    searchPath,
    callBackSetSuggestedCentres,
    onClose
  } = _ref;
  const style = navStyle;
  const {
    0: loadingLocation,
    1: setLoadingLocation
  } = useState(false);
  const {
    0: loadingSelectedCentre,
    1: setLoadingSelectedCentre
  } = useState(false);
  const {
    0: centreInput,
    1: setCentreInput
  } = useState('');
  const Link = useContext(LinkContext);
  const analytics = useAnalytics();

  // Inject a `.displayTitle` field for better rendering
  const centresWithDisplayTitle = useMemo(() => (centres !== null && centres !== void 0 ? centres : []).map(centre => _objectSpread(_objectSpread({}, centre), {}, {
    displayTitle: getCentreDisplayTitle(centre)
  })), [centres]);
  const onFoundCentres = useCallback((inputVal, foundCentres) => analyticsUtils.gaTagTracking({
    event: analyticsUtils.events.SEARCH,
    eventCategory: analyticsUtils.categories.CENTRE_SEARCH,
    eventAction: analyticsUtils.actions.SEARCH_SHOWN,
    eventLabel: inputVal !== null && inputVal !== void 0 ? inputVal : '',
    noReturnedResults: foundCentres.length
  }), []);
  const recentCentres = useRecentCentres();
  const {
    0: suggestedCentres,
    1: setSuggestedCentres
  } = useState(() => {
    // Filter out the current centre from suggestions
    const filteredSlugs = currentCentre ? recentCentres.filter(slug => slug !== currentCentre.slug) : recentCentres;
    return filteredSlugs
    // Convert it into a complete object
    .map(slug => centresWithDisplayTitle.find(centre => centre.slug === slug))
    // Clear out any bad data
    .filter(centre => Boolean(centre))
    // Limit the number of suggestions we return
    .slice(0, MAX_SUGGESTIONS);
  });
  const onCentreSelected = useCallback((centre, isKeyboardSelection) => {
    setLoadingSelectedCentre(true);
    analytics.trackEvent({
      type: 'legacy',
      data: {
        event: analyticsUtils.events.SEARCH,
        eventCategory: analyticsUtils.categories.CENTRE_SEARCH,
        eventAction: analyticsUtils.actions.SEARCH_RESULT_ClICKED,
        eventLabel: centreInput,
        centreResultClicked: centre.title
      }
    });
    onClose === null || onClose === void 0 || onClose();
    if (isKeyboardSelection) {
      // For keyboard users, pressing Enter doesn't trigger the <Link> tag, so
      // we have to do a manual route change
      location.assign(searchPath ? "/".concat(centre.slug).concat(searchPath) : "/".concat(centre.slug));
    }
  }, [centreInput, analytics, onClose, searchPath]);
  const getSuggestedCentresNearMe = useCallback(() => {
    setLoadingLocation(true);
    analyticsUtils.gaTagTracking({
      event: analyticsUtils.events.SEARCH,
      eventCategory: analyticsUtils.categories.CENTRE_SEARCH,
      eventAction: analyticsUtils.actions.CLICK_TO_SET_LOCATION
    });
    try {
      // For browsers that do not support geolocation
      navigator.geolocation.getCurrentPosition(position => {
        const nearestCentres = getNearestCentres(position.coords.latitude, position.coords.longitude, centresWithDisplayTitle).slice(0, MAX_SUGGESTIONS);
        setSuggestedCentres(nearestCentres);
        if (callBackSetSuggestedCentres) {
          callBackSetSuggestedCentres(nearestCentres);
        }
        setLoadingLocation(false);
      }, () => {
        setLoadingLocation(false);
      }, {
        timeout: 10000
      });
    } catch (e) {
      setLoadingLocation(false);
      // TODO: Verify this is the right event
      analyticsUtils.gaTagTracking({
        event: analyticsUtils.events.SEARCH,
        eventCategory: analyticsUtils.categories.CENTRE_SEARCH,
        eventAction: analyticsUtils.actions.CLICK_TO_SET_LOCATION_DENIED
      });
    }
  }, [centresWithDisplayTitle, callBackSetSuggestedCentres]);
  const CentreRow = _ref2 => {
    let {
      centre
    } = _ref2;
    return centre ? /*#__PURE__*/_jsxs(Link, {
      "data-test-id": "centre-search-result",
      to: searchPath ? "/".concat(centre.slug).concat(searchPath) : "/".concat(centre.slug),
      onClick: () => {
        trackClickEvent(analyticsUtils.categories.CENTRE_SEARCH, analyticsUtils.actions.CENTRE_SELECTED, centre.displayTitle);
      },
      "data-id": "centre-selector_index_FormCentrePickerAs_Link",
      children: [/*#__PURE__*/_jsx("span", {
        className: style.centreName,
        "data-id": "centre-selector_index_FormCentrePickerAs_Link_span",
        children: centre.title
      }), /*#__PURE__*/_jsx("span", {
        className: style.centreState,
        "data-id": "centre-selector_index_FormCentrePickerAs_Link_span_3",
        children: centre.state
      })]
    }) : /*#__PURE__*/_jsx("p", {
      "data-id": "centre-selector_index_FormCentrePickerAs_p",
      children: "No results"
    });
  };
  return /*#__PURE__*/_jsxs("div", {
    className: style['find-a-centre'],
    "data-test-id": "centre-selector",
    "data-id": "centre-selector_index_FormCentrePickerAs_div",
    children: [/*#__PURE__*/_jsx(CentrePicker, {
      as: FormCentrePickerAs,
      centres: centresWithDisplayTitle,
      pickerStyle: navStyle,
      isLoading: loadingSelectedCentre,
      mainLabel: 'Centre',
      CentreRow: CentreRow,
      inputLabel: config.inputLabel,
      centreToString: centreToString,
      onInputValue: setCentreInput,
      onFoundCentres: onFoundCentres,
      onCentreSelected: onCentreSelected,
      onFocus: trackSearchStarted,
      id: config.id,
      "data-id": "centre-selector_index_FormCentrePickerAs_div_CentrePicker"
    }), /*#__PURE__*/_jsxs("button", {
      className: style['use-location'],
      onClick: getSuggestedCentresNearMe,
      "data-id": "centre-selector_index_FormCentrePickerAs_div_button",
      children: [/*#__PURE__*/_jsx(Icon, {
        type: "location-drop-pin",
        size: "small",
        className: style.UseLocationIcon,
        "data-id": "centre-selector_index_FormCentrePickerAs_button_Icon"
      }), /*#__PURE__*/_jsx("span", {
        "data-id": "centre-selector_index_FormCentrePickerAs_button_span",
        children: config.locationLabel
      }), loadingLocation && /*#__PURE__*/_jsx("div", {
        className: style['spinner-container'],
        "data-id": "centre-selector_index_FormCentrePickerAs_div",
        children: /*#__PURE__*/_jsx(Spinner, {
          "data-id": "centre-selector_index_FormCentrePickerAs_div_Spinner"
        })
      })]
    }), suggestedCentres.length ? /*#__PURE__*/_jsxs("div", {
      className: style.suggested,
      "data-id": "centre-selector_index_FormCentrePickerAs_div",
      children: [/*#__PURE__*/_jsx("div", {
        className: style.subtitle,
        "data-id": "centre-selector_index_FormCentrePickerAs_div_div_13",
        children: config.suggestedCentresLabel
      }), /*#__PURE__*/_jsx("ul", {
        className: style['suggested-items'],
        "data-id": "centre-selector_index_FormCentrePickerAs_div_ul",
        children: suggestedCentres.map(centre => /*#__PURE__*/_jsx("li", {
          "data-id": "centre-selector_index_FormCentrePickerAs_li",
          children: /*#__PURE__*/_jsx(Link, {
            to: searchPath ? "/".concat(centre.slug).concat(searchPath) : "/".concat(centre.slug),
            className: style['suggested-item'],
            onClick: onClose,
            "data-id": "centre-selector_index_FormCentrePickerAs_li_Link",
            children: centre.displayTitle
          })
        }, centre.slug))
      })]
    }) : null]
  });
};